import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Provider } from "react-redux";
import store from "./redux/store";
import ClarityScript from "./ClarityScript";
import GtagScript from "./GtagScript";
import AuthAutoRefresh from "./authroute/AuthAutoRefresh";
import { attachStore, setUnauthorizedHandler } from "./api/api.js";
import { attachSmartAdvisoryStore } from "./api/smartAdvisoryApi";
import { logout } from "./redux/slices/authSlice";

attachStore(store);
attachSmartAdvisoryStore(store, () => store.dispatch(logout()));
setUnauthorizedHandler(() => store.dispatch(logout()));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_CLIENT_ID}>
    <Provider store={store}>
      <AuthAutoRefresh>
        <ClarityScript />
        <GtagScript />
        <App />
      </AuthAutoRefresh>
    </Provider>
  </GoogleOAuthProvider>,
);

reportWebVitals();
